const doc = [({"ko":({"labelTop":({"company":"회사 명", "email":"이메일 주소", "firstname":"이름", "lastname":"성", "phone":"전화 번호"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;